var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-main',[_c('v-container',[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('keep-alive',[_c('router-view')],1)],1),_c('small',{staticStyle:{"opacity":"0.2"}},[_vm._v(" v15.09.2022-08:00 ")])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }